import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Field, formValueSelector } from 'redux-form/immutable';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import range from 'lodash/range';

import { Endpoints } from '../../../app/lib/LeanLinkService';
import { DatesInput } from '../../../app/components/Form/DatesInput/DatesInput';
import withAvailabilitiesForm from '../../../app/Resources/View/components/AvailabilitiesWidget/withAvailabilitiesForm';
import * as styles from './styles.css';
import Button from '../../../app/components/Button';
import StateButton from '../../../app/Resources/View/components/AvailabilitiesWidget/StateButton';
import withAvailableDateSetting from '../../../app/containers/withAvailableDateSetting';
import withStaffingCompanyGroup from '../../containers/withStaffingCompanyGroup';
import { useTranslation, withTranslation } from 'react-i18next';

const AVAILABLE_DATES_FIELD = 'availableDates';

const availableDateSettingToFieldProps = availableDateSetting => (index) => {
  if (availableDateSetting[`period${index}Enabled`]) {
    return {
      fieldName: `period${index}status`,
      label: availableDateSetting[`period${index}Name`],
    };
  }
  return null;
};

const PeriodFields = compose(
  withTranslation(),
  withStaffingCompanyGroup,
  withProps(({ staffingCompanyGroup }) => ({
    availableDateSettingId: staffingCompanyGroup.availableDateSetting,
  })),
  withAvailableDateSetting,
  withProps(({ availableDateSetting }) => {
    const availableSettingForPeriod = availableDateSettingToFieldProps(availableDateSetting);
    const indexes = range(1, 9);
    const fields = indexes.map(i => availableSettingForPeriod(i)).filter(o => o);
    if (fields.length > 4) {
      const fieldParts = [
        {
          key: 'part1',
          fields: fields.slice(0, 4),
        },
        {
          key: 'part2',
          fields: fields.slice(4, 8),
        },
      ];
      return {
        fieldParts,
      };
    }
    return {
      fieldParts: [{
        key: 'part1',
        fields: fields.slice(0, 4),
      }],
    };
  }),
)(({ fieldParts, t }) => (
  <React.Fragment>
    {fieldParts.map(({ key, fields }) => (
      <table key={key} className="table table-condensed">
        <thead>
          <tr>
            <th />
            {fields.map(({ fieldName, label }) => (
              <th key={fieldName}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>{t("Tillgänglig")}</b></td>
            {fields.map(({ fieldName }) => (
              <td key={fieldName} rowSpan="3">
                <Field
                  name={fieldName}
                  component={StateButton}
                />
              </td>
            ))}
          </tr>
          <tr>
            <td><b>{t("Info saknas")}</b></td>
          </tr>
          <tr>
            <td><b>{t("Ej tillgänglig")}</b></td>
          </tr>
        </tbody>
      </table>
    ))}
  </React.Fragment>
));
function Availabilities({
  month,
  onChangeMonth,
  handleSubmit,
  isLoading,
  periodHighlights,
  hasDates,
}) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-md-4 col-md-offset-4">
        <h2 className={styles.header}>{t("Tillgänglighet")}</h2>
        <Field
          label={t("Tillgänglighet")}
          name={AVAILABLE_DATES_FIELD}
          component={DatesInput}
          onChangeMonth={onChangeMonth}
          month={month}
          daysWeekTitle={t("dag...")}
          periodHighlights={periodHighlights}
          public
          hideRepeat
          hideInput
          hideClear
        />
        {hasDates && (
          <React.Fragment>
            <PeriodFields />
            <Button
              icon="save"
              variant="primary"
              className="pull-right"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {t("Spara tillgängligheten")}
            </Button>
          </React.Fragment>
        )}

        <p>{t("Klicka på ett datum, veckonummer i kanten eller på månadsnamnet för att markera")}
          {t("eller avmarkera vilka dagar du har möjlighet att arbeta.")}</p>
      </div>
    </div>
  );
}

Availabilities.propTypes = {
  month: PropTypes.string.isRequired,
  onChangeMonth: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasDates: PropTypes.bool.isRequired,
};

export default compose(
  withProps({
    avoidAutoPost: true,
    isPublic: true,
  }),
  withAvailabilitiesForm(
    Endpoints.public.resourceApi.availableDates.list,
    Endpoints.public.resourceApi.availableDates.patch,
    'resource_availabilities_form',
    AVAILABLE_DATES_FIELD,
  ),
  connect(
    (state, { form }) => {
      const dates = formValueSelector(form)(state, AVAILABLE_DATES_FIELD);
      return {
        hasDates: dates.size > 0,
      };
    }),
)(Availabilities);
